import ky from 'ky';
import type { Options } from 'ky';

const baseURL = import.meta.env.VITE_APP_API_AI_URL;

interface StreamConfig extends Options {
  onChunk?: (chunk: string) => void;
}

const api = ky.create({
  prefixUrl: baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  timeout: 100000,
});

export const apiAiClient = {
  get: async <T>(url: string, options?: Options): Promise<T> => {
    return api.get(url, options).json<T>();
  },

  post: async <T>(url: string, data?: unknown, options?: Options): Promise<T> => {
    return api.post(url, { json: data, ...options }).json<T>();
  },

  put: async <T>(url: string, data?: unknown, options?: Options): Promise<T> => {
    return api.put(url, { json: data, ...options }).json<T>();
  },

  patch: async <T>(url: string, data?: unknown, options?: Options): Promise<T> => {
    return api.patch(url, { json: data, ...options }).json<T>();
  },

  delete: async <T>(url: string, options?: Options): Promise<T> => {
    return api.delete(url, options).json<T>();
  },

  postStream: async <T>(url: string, data?: unknown, config?: StreamConfig): Promise<T> => {
    const response = await api.post(url, {
      json: data,
      headers: {
        'Accept': 'text/event-stream',
        'X-Accel-Buffering': 'no'
      }
    });

    const reader = response.body?.getReader();
    const decoder = new TextDecoder();

    while (reader) {
      const { done, value } = await reader.read();
      if (done) break;
      
      const chunk = decoder.decode(value);
      const lines = chunk.split('\n');
      lines.forEach(line => {
        if (line.trim()) {
          config?.onChunk?.(line);
        }
      });
    }

    return {} as T;
  },
};

export default api;
